import { api } from "./api";
import ShowNotifications from "../helper/ShowNotifications";

class MasterApi {
  // Location APIs
  getLocations = async (params) => {
    try {
      const response = await api.get("location", { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Fetch Location(s). Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  getLocationById = async (id) => {
    try {
      const response = await api.get(`location/${id}`);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Fetch Location details. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  saveLocation = async (data) => {
    try {
      const response = await api.post("/location", data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Save Location. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  deleteLocation = async (id) => {
    try {
      const response = await api.delete(`/location/${id}`);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Delete Location. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  // Category APIs moved to CategoryAPIs.js
}

const masterApi = new MasterApi();
export default masterApi;

export const {
  getLocations,
  getLocationById,
  saveLocation,
  deleteLocation,
} = masterApi;